import React, { useState } from 'react';
import { Input, TextArea } from '../common/FormFields';
import { Button } from '../common/Button';
import { queueEmail } from '../../services/emailService';
import { Toast } from '../common/Toast';

export const ContactForm = ({ onBack }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await queueEmail('admin@oversizehub.net', 'Custom Plan Request', {
        template: 'CUSTOM_PLAN_REQUEST',
        variables: formData
      });

      setToast({
        type: 'success',
        message: 'Request sent successfully! We will contact you shortly.'
      });

      setTimeout(onBack, 2000);
    } catch (error) {
      setToast({
        type: 'error',
        message: 'Failed to send request. Please try again.'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto">
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-white">Request Custom Plan</h2>
          <p className="text-gray-400 mt-2">
            Tell us about your needs and we'll create a custom solution for you
          </p>
        </div>

        <Input
          label="Full Name"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          required
          className="bg-gray-700 border-gray-600 text-white"
          labelClassName="text-gray-300"
        />

        <Input
          label="Email"
          type="email"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          required
          className="bg-gray-700 border-gray-600 text-white"
          labelClassName="text-gray-300"
        />

        <Input
          label="Phone"
          type="tel"
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          required
          className="bg-gray-700 border-gray-600 text-white"
          labelClassName="text-gray-300"
        />

        <Input
          label="Company Name"
          value={formData.company}
          onChange={(e) => setFormData({ ...formData, company: e.target.value })}
          required
          className="bg-gray-700 border-gray-600 text-white"
          labelClassName="text-gray-300"
        />

        <TextArea
          label="Tell us about your needs"
          value={formData.message}
          onChange={(e) => setFormData({ ...formData, message: e.target.value })}
          rows={4}
          required
          className="bg-gray-700 border-gray-600 text-white"
          labelClassName="text-gray-300"
        />

        <div className="flex gap-3">
          <Button
            type="button"
            variant="default"
            onClick={onBack}
            className="flex-1 bg-gray-700 hover:bg-gray-600 text-white"
          >
            Back
          </Button>
          <Button
            type="submit"
            variant="primary"
            className="flex-1 bg-red-600 hover:bg-red-700 text-white"
            loading={loading}
          >
            Send Request
          </Button>
        </div>
      </form>

      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </div>
  );
};